import { Drawer } from '@mui/material';
import { ThemeProvider, useTheme } from '@mui/material/styles';
import BookingConfirmation from '../../../../pages/Automation/components/BookingConfirmation';
import { useTranslation } from "react-i18next";

interface Benefit {
  title: string;
  description: string;
}

interface IBookingConfirmationDrawerProps {
  open: boolean;
  onClose: () => void;
  openAfterConfirmation: () => void;
  id: any;
  refetch: () => void;
  mainInfoTitle?: string;
  mainInfoDescription?: string;
  generalOverviewTitle?: string;
  generalOverviewDescription?: string;
  benefitsTitle?: string;
  benefitsDescription?: string;
  benefits?: Benefit[];
}

const BookingConfirmationDrawer = ({
  open,
  onClose,
  openAfterConfirmation,
  id,
  refetch,
  mainInfoTitle,
  mainInfoDescription,
  generalOverviewTitle,
  generalOverviewDescription,
  benefitsTitle,
  benefitsDescription,
  benefits,
}: IBookingConfirmationDrawerProps) => {

    const {
      i18n: { language },
    } = useTranslation();
    const isRtl = language == "ar";
    const theme = useTheme();
    const ltrTheme = { ...theme, direction: 'ltr' as const };

  return (
    <ThemeProvider theme={ltrTheme}>
      <Drawer
        anchor={isRtl ? 'left' : 'right'}
        open={open}
        onClose={onClose}
        PaperProps={{
          sx: {
            width: { xs: '100%', sm: '480px', md: '570px' },
          },
        }}
      >
        <BookingConfirmation
          onclose={onClose}
          openAfterConfirmation={openAfterConfirmation}
          id={id}
          refetch={refetch}
          mainInfoTitle={mainInfoTitle}
          mainInfoDescription={mainInfoDescription}
          generalOverviewTitle={generalOverviewTitle}
          generalOverviewDescription={generalOverviewDescription}
          benefitsTitle={benefitsTitle}
          benefitsDescription={benefitsDescription}
          benefits={benefits}
          inDrawer
        />
      </Drawer>
    </ThemeProvider>
  );
};

export default BookingConfirmationDrawer;
